import { IApiClient } from "../api-client";
import { EnvType } from "../services";

interface IHlsChunkerApiClient {}

export default class HlsChunkerApiClient implements IHlsChunkerApiClient {
  readonly servicePort = 9595;
  readonly serviceBaseUrl = "hlschunker-service/native-chunks";

  hlsChunkerApiClient: IApiClient;

  constructor(hlsChunkerApiClient: IApiClient, envType: EnvType) {
    this.hlsChunkerApiClient = hlsChunkerApiClient;
    if (envType === "local") this.hlsChunkerApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  //------Utils------
  GetApiUrl(): string {
    return this.hlsChunkerApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
